export default "__VITE_ASSET__RizkL9SC__"